import { Injectable, Output, EventEmitter } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Observable, Observer, BehaviorSubject } from 'rxjs';
import { User, AuthenticateResponse, UserResponse, UsersResponse } from '../models/User';
import { tokenNotExpired } from 'angular2-jwt';
import { HttpHelperService } from "../services/utility/http-helper.service";

@Injectable()
export class AuthService {
  // @Output() didLogInUser: EventEmitter<any> = new EventEmitter();
  // @Output() didLogOutUser: EventEmitter<any> = new EventEmitter();
  user$: BehaviorSubject<User> = new BehaviorSubject(null);
  authToken: string;

  constructor(
    private http:Http,
    private httpHelperService:HttpHelperService,
  ) { }

  //================
  //HTTP -- REST API

  //Http call to Users REST API, returns an observable "userStream"
  private http_loginUser(email:string, password:string):Observable<AuthenticateResponse>{
    //Fetch single user from rest api
    let headers = new Headers();
    let apipath = '/api/users/authenticate/';
    let apiurl = this.httpHelperService.urlFromPath(apipath);  //baseurl + hostname + producturl
    let userStream$ = this.http.post(apiurl, {email: email, password: password}, {headers:headers})
    .map(res => {
      //will only be called upon 200 success
      let authResponse = res.json() as AuthenticateResponse;  //converts the _body to json object and casts as UserResponse
      authResponse.user = User.fromJson(authResponse.user);  //convert responseUser to User  
      //save to disk
      if(authResponse.success){
        this.storeUserData(authResponse.token, authResponse.user);
         return authResponse;
      }
      console.error('warning: unhandled response for authenticate user');
      //maps return Observable of return value
    })
    .catch((error:any) => {
     //...errors if any
      let errResponse = error.json() as AuthenticateResponse;
      if(error.status == 0){ errResponse.msg = "Sign In Failed.  Unable to connect to server."; }
      else if(error.status >=400 && error.status < 500){
        errResponse.msg = "Login Failed.  Please check your email and password."
      }
      return Observable.throw(errResponse);
    });

    return userStream$
  }


  //=========================
  //Private Methods

  //save user login info: token + user
  private storeUserData(token, user){
    localStorage.setItem('id_token', token);
    localStorage.setItem('user', JSON.stringify(user));
    this.authToken = token;
    this.user$.next(user);

  }

  //retrieve JWT from local storage
  private loadTokenFromStorage(){
    let token = localStorage.getItem('id_token');
    return token;
  }

  //load user from storage
  //return: user or null
  private loadUserFromStorage(){
    let stringUser = localStorage.getItem('user');
    let user = JSON.parse(stringUser) as User;
    return user;
  }
  

  private clearData(){
    this.authToken = null;
    this.user$.next(null);
    localStorage.clear();
  }



  //==================
  //Public Methods

  public restorePreviousLogin(){
    //guard against invalid token;
    let tokenValid = tokenNotExpired('id_token');
    if(!tokenValid){
      this.clearData();
      return;
    }
    //load the user and token
    let user = this.loadUserFromStorage();
    this.user$.next(user);
    this.authToken = this.loadTokenFromStorage();
    // console.log('restorePreviousLogin success with user', user);
  }

  //Simplified Get.  Offloaded processing to http_loginUser
  // Returns an observable stream that emits User and immediately completes.
  public loginUser(email: string, password: string): Observable<AuthenticateResponse> {
    let userStream$ = this.http_loginUser(email, password);
    return userStream$;
  }

  //clears out user login info
  public logoutUser(){
    // console.log('authservice: performing logout out of user');
    this.clearData();
    // this.didLogOutUser.emit(null);
  }

}


//=================
//Unused Code

//load token if necessary for HTTP POST to admin routes
    // if(!this.authToken) { this.loadToken() }

      // console.log('res', res);
      // console.log('res.status', res.status);
      // console.log('res.statusText', res.statusText);
      //**never gets called.  This map only occurs if no error.  Otherwise, error gets thrown with response body, but I'm having trouble extracting it from the error.
        // let message = response.msg;
        // console.log('throwing message', message);
        // throw message;
             //status = 404
      //statusText = Not Found
      // console.log('errBody', errResponse);
  //      let errMsg = (error.message) ? error.message :
  //  error.status ? `${error.status} - ${error.statusText}` : 'Server error';
  //       console.error('errMsg', error.status); // log to console instead      
  // Observable.throw(error.json().error || 'Server error')
  // let errResponse = JSON.parse(error._body) as UserResponse;
      // .catch((err) => {
    //   console.log('encountered error on making http request from authservice');
    //   // Do messaging and error handling here 
    //   return Observable.throw(err)
    // })

    // console.log('authservice: checking if user is logged in');
    // if (!tokenValid){ this.logout() }  //this will trigger inf loop with navbar and logout
    // return tokenValid;

        // //If user is logged in with valid token, return user.    
    // // otherwise, clear out the login and return null.
    // if( this.loggedIn() ){
    //   //return the user from cache or storage
    //   if(this.user$_xx){
    //     return this.user$_xx;
    //   } else {
 
    //   }
    // } else {
    //   this.clearData();
    //   return null;
    // }


  // //if logged in w/ valid token, return the user.
  // // otherwise, null
  // public getLoggedInUser(): User {
  //   //guard loggedIn
  //   if(!this.loggedIn()){
  //     return null;
  //   }
  //   //load user if necessary
    
  //   if(!this.user$.value) { this.loadUser() }
    
  //   return this.user$.value;
  // }

  // // NOT USED!  No longer needed now that I'm using a behaviorSubject to store/emit valid logged in user.
  // //the tokenNotExpired function checks if JWT exists in local storage, 
  //   // and if it does, whether it has expired or not.
  // public loggedIn(){
  //   let tokenValid = tokenNotExpired('id_token');
  //   if (!tokenValid && this.authToken){
  //     //an expired token exists.  Logout the user.
  //     this.logoutUser();
  //   }
  //   return tokenValid;
  // }
        // console.log('auth announces user is logged in');
        // this.didLogInUser.emit(user);



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts